/**
 * Shared constants for the jerry ad-hoc query workbench.
 *
 * Everything in this folder is fork-local. Keeping the route path under a
 * `/jerry` prefix guarantees it can never collide with a route upstream
 * Metabase adds later, which keeps rebases boring.
 */

/** Route path as mounted inside `routes.jsx` (no leading slash). */
export const ADHOC_QUERY_ROUTE_PATH = "jerry/adhoc-query";

/** Absolute path, for links and `push()`. */
export const ADHOC_QUERY_PATH = `/${ADHOC_QUERY_ROUTE_PATH}`;

/** Key prefix for the IndexedDB record holding a user's tabs. */
export const STORAGE_KEY_PREFIX = "metabase.jerry.adhoc-query";

/**
 * Each open tab keeps a mounted `NativeQueryEditor`, which is not free: every
 * editor registers a document-level listener and subscribes to the databases /
 * snippets entity lists. This cap keeps that bounded.
 */
export const MAX_TABS = 20;

/**
 * Result datasets are held in memory (up to `HARD_ROW_LIMIT` rows each), so the
 * number of retained results per tab has to be bounded too. Oldest *completed*
 * results are evicted first; running ones are never evicted.
 */
export const MAX_RESULTS_PER_TAB = 20;

/** SQL edits are high-frequency, so writes to localStorage are debounced. */
export const PERSISTENCE_DEBOUNCE_MS = 500;

/** Fallback editor height, used when the window size isn't known yet. */
export const DEFAULT_EDITOR_HEIGHT = 400;
